// Values match Firebase Auth `providerData[].providerId`.
export enum AuthProvider {
  Email = 'password',
  Google = 'google.com',
  Apple = 'apple.com',
}
